import { Service } from "@roc/feature-app-core";

const url = {
  GET_COMP_ALL_PHOTOS:
    '/api/v1/property/compTool/getCompAllPhotos',
  GET_ALL_COMP_PHOTOS_GROUP_BY_DATE:
    '/api/v1/property/compTool/getAllCompPhotosGroupByDate'
}


export class CompToolPhotosService extends Service {

  fetchAllCompPhotos(mlsId: string) {
    return this.get(`${url.GET_COMP_ALL_PHOTOS}?mlsId=${mlsId}`, null, { disableGlobalLoading: true });
  }

  fetchAllCompPhotosGroupByDate(property_id: string) {
    return this.get(`${url.GET_ALL_COMP_PHOTOS_GROUP_BY_DATE}?propertyId=${property_id}`, null, { disableGlobalLoading: true });
  }

}